const isDev = process.env.NODE_ENV !== 'production';

export default isDev
  ? 'http://localhost:5000'
  : 'https://api.cogumelos.compjunior.com.br';
